import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
type PricingCardProps = {
  title: string;
  featured?: boolean;
  includes: string;
  idealFor?: string;
  price: string | null;
  ctaLabel: string;
  href: string;
  image?: string;
};
export function PricingCard({
  title,
  featured = false,
  includes,
  idealFor,
  price,
  ctaLabel,
  href,
  image
}: PricingCardProps) {
  return <article className={`relative flex flex-col rounded-3xl p-7 sm:p-8 ${featured ? 'border-2 border-sun bg-raised' : 'border-2 border-brand bg-raised'}`} data-id="element-194" data-mp="2erx8rp1srgg9">
      {featured && <span className="absolute -top-3.5 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full bg-sun px-4 py-1 text-xs font-black uppercase tracking-wider text-ink" data-id="element-195" data-mp="25240oy0v5jgr">
          <StarIcon className="h-3.5 w-3.5 fill-ink" aria-hidden="true" data-id="element-196" data-mp="2xkhwks2n2vd7" />
          Más completo
        </span>}
      <h3 className={`text-center text-xl font-black uppercase leading-tight ${featured ? 'text-sun' : 'text-brand'}`} data-id="element-197" data-mp="2sr6qwu9kckmv">{title}</h3>

      {image && <img src={image} alt="" className="mx-auto mt-5 w-full max-w-[260px]" data-id="element-198" data-mp="37jfc8b8tk4g5" />}

      <dl className="mt-6 space-y-4 border-t border-line pt-6 text-left" data-id="element-199" data-mp="37li5r596kfpm">
        <div data-id="element-200" data-mp="2stzpr7gbml69">
          <dt className="text-xs font-black uppercase tracking-widest text-muted" data-id="element-201" data-mp="2ssga9j2hoe5j">Incluye</dt>
          <dd className="mt-1 text-base font-bold text-white" data-id="element-202" data-mp="2xrsxw616pp96">{includes}</dd>
        </div>
        {idealFor && <div data-id="element-203" data-mp="2jw7b85ifbhjx">
            <dt className="text-xs font-black uppercase tracking-widest text-muted" data-id="element-204" data-mp="2osnxsv9z5nuw">Ideal para</dt>
            <dd className="mt-1 text-base text-cream/90" data-id="element-205" data-mp="29vwvoe8x1y1l">{idealFor}</dd>
          </div>}
      </dl>

      <div className="mt-auto pt-7 text-center" data-id="element-206" data-mp="2eui06pv7b3vu">
        {price ? <p className="text-5xl font-black text-white" data-id="element-207" data-mp="2ewkx7turtxa2">{price}</p> : <>
            <p className="text-2xl font-black text-white" data-id="element-208" data-mp="827b5ionxrvn">Precio en tu moneda local</p>
            <p className="mt-1 text-sm text-muted" data-id="element-209" data-mp="d2llx8hnffxd">El importe final se muestra en el checkout según tu país.</p>
          </>}
        <div className="mt-6" data-id="element-210" data-mp="6n4qt110aco1">
          <CTAButton href={href} variant={featured ? 'sun' : 'primary'} size="md" fullWidth data-id="element-211" data-mp="6m3aoi54uzzg">
            {ctaLabel}
          </CTAButton>
        </div>
      </div>
    </article>;
}